import _extends from '@babel/runtime/helpers/extends';
import React__default, { useEffect } from 'react';
import { TaktIdProvider, createStormTaktId, IconButton, InlineAlert } from '@amzn/storm-ui';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';
import { s as starSolid, a as star } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-B8hoEVqo.js';

const PageTitleIcon = ({
  isActive,
  onClick,
  alertVariant = 'success',
  alertMessage,
  taktId,
  taktValue,
  ...rest
}) => {
  const [showAlert, setShowAlert] = React__default.useState(false);
  useEffect(() => {
    if (alertVariant && alertMessage) {
      setShowAlert(true);
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
    return noop;
  }, [alertVariant, alertMessage]);
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('page-header-title-icon')
  }, /*#__PURE__*/React__default.createElement(IconButton, _extends({}, rest, {
    icon: isActive ? starSolid : star,
    variant: "transparent",
    onClick: onClick
  })), showAlert && /*#__PURE__*/React__default.createElement(InlineAlert, {
    variant: alertVariant,
    message: alertMessage,
    "aria-live": "assertive"
  }));
};

export { PageTitleIcon as P };
//# sourceMappingURL=PageTitleIcon-Ctg83Q13.js.map
